var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Group, Rect } from '../../element';
import { createRichText } from '../../rich';
import * as lodash from '../../utils/lodash';
import { getBoxLabelPosition } from '../../utils/textLayout';
export function renderMarkArea(axisModel) {
    var markAreas = axisModel.getOption().markAreas;
    var axis = axisModel.shortType;
    var scale = axisModel.scale;
    if (!markAreas || !markAreas.length) {
        return null;
    }
    var group = new Group({
        key: axisModel.getKey('markarea'),
    });
    markAreas.forEach(function (areaOption) {
        var start = areaOption.start, end = areaOption.end, label = areaOption.label, areaStyle = areaOption.areaStyle;
        if (!(lodash.isNumber(start) || lodash.isNumber(end))) {
            return;
        }
        var startPosition = scale.scale(start);
        var endPosition = scale.scale(end);
        var _a = axisModel.parentModel.getState(), top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom, gridWidth = _a.width, gridHeight = _a.height;
        var x;
        var y;
        var width;
        var height;
        if (axis === 'x') {
            startPosition = lodash.clamp(startPosition, left, right);
            endPosition = lodash.clamp(endPosition, left, right);
            x = startPosition;
            y = top;
            width = endPosition - startPosition;
            height = gridHeight;
        }
        else if (axis === 'y') {
            startPosition = lodash.clamp(startPosition, top, bottom);
            endPosition = lodash.clamp(endPosition, top, bottom);
            x = left;
            y = startPosition;
            width = gridWidth;
            height = endPosition - startPosition;
        }
        if (startPosition === endPosition) {
            return;
        }
        var data = {
            dataType: 'markArea',
            markArea: areaOption,
        };
        group.add(new Rect(__assign({ x: x,
            y: y,
            width: width,
            height: height,
            data: data }, axisModel.getShapeStyle(areaStyle))));
        if (label.text) {
            var textPosition = getBoxLabelPosition({ x: x, y: y, width: width, height: height }, label.position, label.distance, axis === 'x' ? 'top' : 'right');
            group.add(createRichText(__assign(__assign({ text: label.text }, axisModel.getTextStyle(label)), textPosition)));
        }
    });
    return group;
}
export function getDefaultMarkAreaOption() {
    return {
        label: {
            text: '',
            distance: 6,
            position: 'outside',
            color: '#878EA8',
            fontSize: 12,
        },
        areaStyle: {
            lineWidth: 0,
            stroke: 'none',
            fill: '#F0F2F6',
            opacity: 0.7,
        },
    };
}
